module.exports = __webpack_public_path__ + "static/media/esther-muehlethaler.f9e21c8d.jpg";